import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { LanguageIcon, UserIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/account')({
  loader: ({ context }) => {
    context.groupLabel = 'account.sidebar.title.account';
    context.childRoutes = [
      {
        id: 'account.sidebar.menu.profile',
        label: 'Profile',
        path: '/account/profile',
        icon: UserIcon,
      },
      {
        id: 'account.sidebar.menu.language',
        label: 'Language',
        path: '/account/language',
        icon: LanguageIcon,
      },
    ];
    return {
      crumb: <CrumbTitle title="account.sidebar.crumb.account" id="account.sidebar.crumb.account" icon={UserIcon} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
